export enum CustomerAccountValue {
  ClassCPrivate = 'class_c_private',
  ClassBSmallBusiness = 'class_b_small_business',
  ClassALarge = 'class_a_large_corp_or_government',
}
